import { getFetchOptions } from "../../utils";
let requestId = 0;
export default function useCartApi() {
    function request(url, data = undefined, method = "POST") {
        const currentRequestId = ++requestId;
        return fetch(url, getFetchOptions(data, true, method))
            .then(response => {
            if (requestId !== currentRequestId) {
                return;
            }
            return response.json();
        });
    }
    const reloadGifts = () => request('/api/cart/gifts/get');
    const addGift = (productId) => request('/api/cart/gifts/add', { productId });
    const removeGift = (productId) => request('/api/cart/gifts/remove', { productId });
    function getGiftable() {
        return fetch('/api/cart/gifts/giftable', { credentials: 'same-origin' }).then(response => response.json());
    }
    const getAtomizers = () => request('/api/cart/atomizers');
    return {
        addGift, getGiftable, reloadGifts, removeGift, getAtomizers
    };
}
